export const tipo_movimientos = {
    INGRESO: 10,
    VENTA: 30,
    COMPRA: 20,
    RETIRO: 40,
    BAJA: 50,
    REAJUSTE: 60,
    DEVOLUCION: 70,
    ABONO_CUENTA: 80,
};

export const niveles_usuario = {
    PROPIETARIO: 100,
    ADMIN: 75,
    BODEGUERO: 50,
    CAJERO: 25,
};

export const opcionesDevolucion = [
    { label: "No era la talla correcta", value: 50 },
    { label: "El producto tenía defectos", value: 10 },
    { label: "Garantía", value: 30 },
    { label: "No cumple con expectativas del cliente", value: 20 },
    { label: "No coincide con la publicidad o empaque", value: 40 },
];

export const opcionesReingreso = [
    { label: "Sí regresa", value: true },
    { label: "No regresa", value: false },
];

// LA DESCRIPCIÓN VA AQUI PORQUE NO LA NECESITAMOS EN BACKEND
// TODO poner una descripcion apropiada
export const acciones_bitacora = [
    { descripcion: "Login", label: "Login" },
    { descripcion: "Crear producto", label: "Crear producto" },
    { descripcion: "Editar producto", label: "Editar producto" },
    { descripcion: "Eliminar producto", label: "Eliminar producto" },
    { descripcion: "Crear usuario", label: "Crear usuario" },
    { descripcion: "Editar usuario", label: "Editar usuario" },
    { descripcion: "Eliminar usuario", label: "Eliminar usuario" },
    { descripcion: "Crear caja", label: "Crear caja" },
    { descripcion: "Editar caja", label: "Editar caja" },
    { descripcion: "Eliminar caja", label: "Eliminar caja" },
    { descripcion: "Anular venta", label: "Anular venta" },
    {
        descripcion: "Devolucion de productos",
        label: "Devolucion de productos",
    },
    {
        descripcion: "Movimiento del inventario",
        label: "Movimiento del inventario",
    },
    { descripcion: "Ingreso de productos", label: "Ingreso de productos" },
];

//  TIPOS DE PAGO
export const pago_total = 100;
export const pago_credito = 200;

//  TIPOS DE UNIDAD DE MEDIDA
export const UNIDAD = 10;
export const CAPACIDAD = 20;
export const PESO = 30;
export const LONGITUD = 40;
export const AREA = 50;
export const VOLUMEN = 60;
export const OTROS = 100;

//  ESTADOS DE FACTURA
export const PROCESO = 10;
export const FACTURADO = 20;
export const ANULADA = 30;
export const ERROR = 40;

// ESTADOS DESPACHO
export const DESPACHO_PENDIENTE = 10;
export const DESPACHO_COMPLETO = 20;

// TIPO PUNTO DE VENTA
export const PVN = "PVN"; // Normal
export const PVMCE = "PVMCE"; // Mostrador-Caja-Entrega

// TIPO METODOS
export const METODO_PAGO = 10;
export const METODO_ENTREGA = 20;

export const fractions = [
    
    { fraction: "1/2", value: 0.5 },
    { fraction: "1/3", value: 0.3333 },
    { fraction: "1/4", value: 0.25 },
    { fraction: "1/5", value: 0.2 },
    { fraction: "1/6", value: 0.1667 },
    { fraction: "1/8", value: 0.125 },
    { fraction: "1/10", value: 0.1 },
    { fraction: "2/3", value: 0.6667 },
    { fraction: "3/4", value: 0.75 },
    { fraction: "3/5", value: 0.6 },
    { fraction: "5/6", value: 0.8333 },
    { fraction: "7/8", value: 0.875 },
    { fraction: "3/8", value: 0.375 },
    { fraction: "5/8", value: 0.625 },
    { fraction: "7/10", value: 0.7 },
];

export const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));

export const formatFraction = (value) => {
    if (value == null || isNaN(value)) return "0";
    if (Number.isInteger(value)) return value.toString();
    const whole = Math.floor(value);
    const decimal = value - whole;

    const match = fractions.find((f) => Math.abs(f.value - decimal) < 0.01);
    if (match) {
        return `${whole > 0 ? whole + " " : ""}${match.fraction}`;
    }

    const precision = 1000;
    const numerator = Math.round(decimal * precision);
    const denominator = precision;
    const divisor = gcd(numerator, denominator);

    const simplifiedNumerator = numerator / divisor;
    const simplifiedDenominator = denominator / divisor;

    return `${whole > 0 ? whole + " " : ""}${simplifiedNumerator}/${simplifiedDenominator}`;
};

export const formatDifference = (value) => {
    if (value == null || isNaN(value)) return "0";
    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);

    // If the value is an integer, return it directly
    if (Number.isInteger(absoluteValue)) {
        return `${isNegative ? "-" : ""}${absoluteValue}`;
    }

    const whole = Math.floor(absoluteValue);
    const decimal = absoluteValue - whole;

    const match = fractions.find((f) => Math.abs(f.value - decimal) < 0.01);
    if (match) {
        return `${isNegative ? "-" : ""}${whole > 0 ? whole + " " : ""}${match.fraction}`;
    }

    const precision = 1000;
    const numerator = Math.round(decimal * precision);
    const denominator = precision;
    const divisor = gcd(numerator, denominator);

    const simplifiedNumerator = numerator / divisor;
    const simplifiedDenominator = denominator / divisor;

    return `${isNegative ? "-" : ""}${whole > 0 ? whole + " " : ""}${simplifiedNumerator}/${simplifiedDenominator}`;
};
